import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SearchSVG } from "../svg/SearchSVG";
import { useTranslation } from "react-i18next";

const useHandleSearch = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const doSearch = (keyword: string) => {
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("keyword", keyword.trim() || "");
    navigate(`?${updatedParams.toString()}`, { replace: true });
  };

  return doSearch;
};

export const SearchInput: React.FC = () => {
  const { t } = useTranslation();

  const doSearch = useHandleSearch();
  const [keyword, setKeyword] = useState<string>("");
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const keywordFromUrl = searchParams.get("keyword") || "";
    setKeyword(keywordFromUrl);
  }, [searchParams]);

  return (
    <div
      className="relative flex h-[12.75rem] flex-col items-center justify-center space-y-4 bg-cover bg-center"
      style={{
        backgroundImage: `url(../../assets/images/find_your_next_plan_image.jpeg)`,
      }}
    >
      <div
        className="absolute inset-0 bg-black opacity-20"
        style={{ backdropFilter: `blur(1.5rem)` }}
      ></div>
      <div className="relative hidden h-[3rem] w-full max-w-[50rem] px-6 sm:h-[4.5rem] sm:px-0">
        <input
          type="text"
          className="h-full w-full rounded-[6.1875rem] py-3 pl-[1.125rem] pr-3 focus:outline-none focus:ring-2 focus:ring-blue-500 sm:pl-[4.5rem]"
          placeholder={t("Search by product name")}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <div className="pointer-events-none absolute inset-y-0 hidden items-center pl-6 sm:flex">
          <SearchSVG />
        </div>
        <button
          onClick={() => {
            doSearch?.(keyword);
          }}
          className="absolute inset-y-0 right-[0.5rem] top-[0.5rem] hidden h-[3.5rem] w-[7rem] items-center justify-center rounded-[6.1875rem] bg-[#A8C6FF] text-[#232323] hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 sm:flex"
        >
          {t("Search")}
        </button>
        <button
          type="button"
          onClick={() => {
            doSearch?.(keyword);
          }}
          className="absolute inset-y-0 right-[2.5rem] flex items-center sm:hidden"
        >
          <SearchSVG />
        </button>
      </div>
    </div>
  );
};
